"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchFilterDropdown = void 0;
var tokens = __importStar(require("@iqmetrix/style-tokens"));
var react_1 = __importStar(require("react"));
var components_1 = require("../../components");
function SearchFilterDropdown(props) {
    var dataIndex = props.dataIndex;
    var _a = __read(react_1.useState({}), 2), searchTerms = _a[0], setSearchTerms = _a[1];
    var handleSearch = function (confirm) {
        confirm();
    };
    var handleReset = function (clearFilters, dataIndex) {
        if (dataIndex) {
            var updatedSearchTerms = searchTerms;
            delete updatedSearchTerms[dataIndex];
            setSearchTerms(updatedSearchTerms);
        }
        if (clearFilters) {
            clearFilters();
        }
    };
    return (react_1.default.createElement("div", { style: { padding: tokens.PaddingBaseXsmall } },
        react_1.default.createElement(components_1.Input, { value: dataIndex ? searchTerms[dataIndex] : "", onChange: function (e) {
                var _a;
                if (dataIndex) {
                    setSearchTerms(__assign(__assign({}, searchTerms), (_a = {}, _a[dataIndex] = e.currentTarget.value, _a)));
                    props.setSelectedKeys([e.currentTarget.value]);
                }
            } }),
        react_1.default.createElement("div", { style: { display: "flex", justifyContent: "flex-start", marginTop: tokens.SpacingBaseXsmall } },
            react_1.default.createElement(components_1.Button, { type: "primary", style: { flexGrow: 1, marginRight: tokens.SpacingBaseXsmall }, onClick: function () { return handleSearch(props.confirm); } }, "Search"),
            react_1.default.createElement(components_1.Button, { ghost: true, style: { flexGrow: 1 }, onClick: function () { return handleReset(props.clearFilters, dataIndex); } }, "Reset"))));
}
exports.SearchFilterDropdown = SearchFilterDropdown;
//# sourceMappingURL=searchFilterDropdown.js.map